<template>
    <el-drawer :title="taskName +'-详细'" class="cleaningDrawer" :append-to-body="true" :visible.sync="cleaningDrawer" :wrapper-closable="false" size='800px' :show-close="false" wrapperClosable>
          
          <!-- <div class="numStatus">
                <el-select v-model="state" placeholder="请选择号码状态" style="maxwidth:136px" @change="sortState">
                    <el-option label="全部" :value="''"></el-option>
                    <el-option label="活跃号" :value="1"></el-option>
                    <el-option label="沉默号" :value="4"></el-option>
                    <el-option label="风险号" :value="5"></el-option>
                    <el-option label="空号" :value="0"></el-option>
                    <el-option label="未检测" :value="100"></el-option>
                </el-select>
          </div> -->
          <el-table  v-loading="waiting"
                    :data="list.tableData"
                    style="width: 100%"
                    innerpage
                    class="detailBox"
                    :cell-class-name="cellClassName"
                    >
                    
                    <el-table-column
                        prop="companyName"
                        label="企业名称"
                        width="228">
                        <template slot-scope="scope">
                                <el-tooltip effect="light" :content="scope.row.companyName" placement="top">
                                 <span class="textOverflow">{{scope.row.companyName}}</span>
                                </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="legalPerson"
                        label="法人"
                        width="72"
                        >
                        <template slot-scope="scope">{{scope.row.legalPerson || '--'}}</template>
                    </el-table-column>
                    <el-table-column
                        prop="estiblishTime"
                        label="成立时间"
                        width="112"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="contactName"
                        label="联系人"
                        width="72">
                        <template slot-scope="scope">
                            {{scope.row.contactName || '--'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="contactInfo"
                        label="手机号"
                        width="110"
                        >
                        <template slot-scope="scope">
                               <span v-for="(item,index) in handlePhShow(scope.row.contactInfo)" :key="index+item" @click="onCopy(item)">
                                   {{item}}
                               </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="keyContact"
                        label="标签"
                        width="72"
                        >
                        <template slot-scope="scope">
                                {{scope.row.keyContact == 1?'关键人':'--'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="state"
                        label="号码状态">
                        <template slot-scope="scope">
                                {{cleaningState[scope.row.state] || '--'}}
                        </template>
                    </el-table-column>
          </el-table>
        <pagination v-if="this.list.tableData.length" :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :key="list.pageNum" />
    </el-drawer>
</template>
<script>
import pagination from '@/components/pagination/'
import { cleaningNumberInfo} from '@/views/clue/api/cleaningApi'
export default {
    components:{
      pagination
    },
    data(){
        return{
            waiting:false,
            cleaningDrawer:false,
            list: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0,
                    tableData: []
                },
            id:'',//清洗任务id
            taskName:'',//任务名称
            state:undefined, //手机号状态
            cleaningState:{0:'空号',1:'活跃号',4:'沉默号',5:'风险号',100:'未检测'}  //state  清洗状态 0-空号 1-实号 4-沉默号 5-风险号 100-未检测
        }
    },
    mounted(){

    },
    methods:{
        iniFun(id,name){
            this.cleaningDrawer  = true
            this.id = id
            this.taskName = name
            this.getcleaningNumberInfo()
        },
        async getcleaningNumberInfo(){
        try{
            let params ={
                tid:this.id,
                pageNum:this.list.pageNum,
                pageSize:this.list.pageSize,
                state:this.state
            }
            this.waiting = true
            const res = await cleaningNumberInfo(params)
            if(res.code == 200){
                this.list.tableData = res.data.records
                this.list.total = res.data.total
            }
            this.waiting = false
            }catch(err){
            this.waiting = true
            }
        },
        sortState(){
            this.list.pageSize = 10
            this.list.pageNum = 1
            this.getcleaningNumberInfo()
        },
         handleSizeChange(val){
            this.list.pageNum = 1
           this.list.pageSize = val
           this.getcleaningNumberInfo()
        },
        handleCurrentChange (val) {
        this.list.pageNum = val
        this.getcleaningNumberInfo()
        },
        //多个手机号展示
        handlePhShow(val){
            return val.split(/\s+/)
        },
        onCopy(txt){
            this.$copyText(txt).then(()=>{
                this.$message.success('复制成功')
            }).catch(()=>{

            })
        },
        cellClassName({row,column}){
            if(column.label == '手机号'){
                return 'cellName'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep{
       .el-drawer__header{
                    padding: 0;
                    padding-left: 24px;
                    height: 46px;
                    font-weight: bold;
                    color: #333333;
                    line-height: 22px;
                    font-size: 16px;
                    border-bottom: 1px solid #F1F1F2;
            }
        .el-drawer__body{
            padding: 24px 24px;
            box-sizing: border-box;
        }
    .detailBox{
         th.el-table__cell .cell{
             padding-left: 0;
         }
        th.el-table__cell{
            &:nth-of-type(1){
                 .cell{
                     padding-left: 30px;
                     box-sizing: border-box;
                 }
            }
           
        }
        
        &.el-table{
            td.el-table__cell div{
             padding-left: 0;
             span{
                 width: 100%;
                 display: block;
             }
           }
           tr{ 
            td.el-table__cell{
                    &:nth-of-type(1){
                        .cell{
                         padding-left:30px;
                       }
                  }
             }
             .cellName{
                 cursor: pointer;
             }
                      
           }
        }
    }
}
.cleaningDrawer{
            .numStatus{
               margin-bottom: 8px; 
            }
       }
</style>